import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { streamsApi, communityApi } from '../api';
import ChatPanel from '../components/ChatPanel';
import './Dashboard.css';

const CREATOR_PLUS_ROLE_ID = '1492514375905316940';

function Dashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    liveStreams: 0,
    totalStreamers: 0,
  });
  const [recentMembers, setRecentMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const isAuthenticated = !!localStorage.getItem('discord_token');
  const [hasCreatorPlus, setHasCreatorPlus] = useState(false);

  useEffect(() => {
    let cancelled = false;

    Promise.all([
      streamsApi.getLive(),
      streamsApi.getAll(),
      communityApi.getRecent(8).catch(() => []),
    ])
      .then(([live, all, members]) => {
        if (cancelled) return;
        setStats({
          liveStreams: live.length,
          totalStreamers: all.length,
        });
        setRecentMembers(members);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      setHasCreatorPlus(false);
      return;
    }

    let cancelled = false;
    const token = localStorage.getItem('discord_token');

    fetch(`${process.env.REACT_APP_API_BASE || '/api'}/user-data`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => {
        if (!cancelled) {
          setHasCreatorPlus(Array.isArray(data.roles) && data.roles.includes(CREATOR_PLUS_ROLE_ID));
        }
      })
      .catch(() => {
        if (!cancelled) setHasCreatorPlus(false);
      });

    return () => { cancelled = true; };
  }, [isAuthenticated]);

  const statCards = [
    { title: 'Live', value: stats.liveStreams, color: '#e94560', to: '/streams' },
    { title: 'Streamer', value: stats.totalStreamers, color: '#00b894', to: '/top-streamers' },
  ];

  if (loading) {
    return (
      <div className="page">
        <div className="loading-container">
          <div className="spinner" />
          <p>Lädt...</p>
        </div>
        <ChatPanel isAuthenticated={isAuthenticated} hasCreatorPlus={hasCreatorPlus} />
      </div>
    );
  }

  return (
    <div className="page">
      <h1>Dashboard</h1>
      <div className="stats-grid stats-grid-compact">
        {statCards.map((item, index) => (
          <div key={index} className="stat-card stat-card-compact" style={{ borderColor: item.color }}>
            <div className="stat-card-content">
              <div className="stat-card-value" style={{ color: item.color }}>{item.value}</div>
              <div className="stat-card-title">{item.title}</div>
            </div>
            <button onClick={() => navigate(item.to)} className="stat-card-link">Anzeigen</button>
          </div>
        ))}
      </div>

      <div className="dashboard-community dashboard-community-large">
        <div className="dashboard-community-header">
          <h2>👥 Community – Neueste Mitglieder</h2>
          <button onClick={() => navigate('/community')} className="dashboard-community-link">
            Alle Mitglieder entdecken →
          </button>
        </div>
        {recentMembers.length === 0 ? (
          <p className="muted">Noch keine Mitglieder. Melde dich mit Discord an, um die Community zu erweitern.</p>
        ) : (
          <div className="dashboard-community-list dashboard-community-list-large">
            {recentMembers.map(m => (
              <div key={m.id} className="dashboard-community-item dashboard-community-item-large">
                <img
                  src={m.avatar_url || 'https://cdn.discordapp.com/embed/avatars/0.png'}
                  alt={m.username || 'User'}
                />
                <div>
                  <div className="dashboard-community-name">{m.global_name || m.username || 'Unbekannt'}</div>
                  {m.global_name && m.username && (
                    <div className="dashboard-community-username">@{m.username}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <ChatPanel isAuthenticated={isAuthenticated} hasCreatorPlus={hasCreatorPlus} />
    </div>
  );
}

export default Dashboard;
